import { queryOptions, useQuery } from '@tanstack/react-query';
import { getValidated } from '@shared/api';
import { currencyKeys } from './keys';
import { CurrenciesResponseSchema } from './schemas';
import { toCurrency } from './mappers';

/**
 * The currency reference list (`GET /api/v1/geo/currencies`). Currencies rarely change, so the
 * query is cached for a day. Mapping in `select` keeps the DTO out of components.
 */
export const currenciesQueryOptions = queryOptions({
  queryKey: currencyKeys.list(),
  queryFn: () => getValidated('api/v1/geo/currencies', CurrenciesResponseSchema),
  select: (res) => (res.data?.currencies ?? []).map(toCurrency),
  staleTime: 24 * 60 * 60 * 1000,
});

export function useCurrencies() {
  return useQuery(currenciesQueryOptions);
}
